import logGoogleTagManagerEvent from './logGoogleTagManagerEvent';

export default function logGoogleTagManagerCreateProductGroup(id: string, name: string) {
	logGoogleTagManagerEvent({
		event: 'cogvio.groupCreate',
		groupCreate: {
			id,
			name,
		},
	});
}
